export default __webpack_public_path__ + "static/media/supper_apps_m2.28292878.png";